module.exports = __webpack_public_path__ + "media/images/front/bg_products_header_top-6a146025ba25c8bce3516245c1e9981d.jpg";